import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=49573d0e&scoped=true&"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIcon.vue?vue&type=style&index=0&id=49573d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49573d0e",
  null
  
)

export default component.exports